module.exports = __webpack_public_path__ + "img/asset_RAY-SOL.0dbe5d4a.png";